import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ConversationDetail } from '../../../../../../core/src/lib/interface/conversation.interface';
import { PersonalEmailReplyBarComponent } from './personal-email-reply-bar.component';

/**
 * Defers the personal-email reply bar into a lazy chunk so the heavy CRM email composer
 * (`CrmSendEmailComponent`, reachable only through `EmailWorkflowService` → the launcher) stays out
 * of the initial bundle. Light services from the same barrel (e.g. `CrmAIDraftService`) that
 * inbox-message-text / inbox-conversation-preview already import remain eager and tree-shake fine —
 * the composer itself is the weight, and it lands in a lazy chunk (verified: webchat-client initial
 * 5.44MB -> 4.24MB, composer in a separate 872KB chunk). Apps that bundle ConversationUIModule but
 * never render a personal-email reply (e.g. the webchat widget) then don't pay for it. Loads
 * immediately when rendered, which only happens on a personal-email thread.
 */
@Component({
  selector: 'inbox-personal-email-reply-bar-defer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PersonalEmailReplyBarComponent],
  template: `@defer (on immediate) {
    <inbox-personal-email-reply-bar [conversationDetail]="conversationDetail()"></inbox-personal-email-reply-bar>
  }`,
})
export class PersonalEmailReplyBarDeferComponent {
  readonly conversationDetail = input.required<ConversationDetail>();
}
